import {
  Badge,
  Box,
  VStack,
  Text
} from '@chakra-ui/react';
import { memo, useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';

const InfoBadge = memo(({ price, website, productUrl, onPopupStateChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const extractStoreName = (url) => {
    try {
      const domain = new URL(url).hostname;
      return domain.replace('www.', '');
    } catch {
      return 'Store';
    }
  };

  const storeName = extractStoreName(productUrl);

  useEffect(() => {
    if (onPopupStateChange) {
      onPopupStateChange(isOpen);
    }
  }, [isOpen, onPopupStateChange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <Box position="relative" ref={containerRef}>
      <motion.div
        animate={isOpen ? {
          scale: [1, 1.15, 1],
        } : { scale: 1 }}
        transition={isOpen ? {
          duration: 1,
          repeat: Infinity,
          ease: "easeInOut"
        } : { duration: 0.2 }}
      >
        <Badge
          cursor="pointer"
          display="flex"
          alignItems="center"
          justifyContent="center"
          w={4}
          h={4}
          p={0}
          borderRadius="full"
          color="white"
          style={{
            boxShadow: "0 0.01rem 0.01rem rgba(0, 0, 0, 0.4)",
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          }}
          _hover={{
            backgroundColor: "rgba(0, 0, 0, 0.9)"
          }}
          onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}
        >
          i
        </Badge>
      </motion.div>
      
      {isOpen && (
        <Box
          position="absolute"
          top="calc(100% + 8px)"
          right="0"
          bg="blackAlpha.500"
          border="2px solid"
          borderColor="gray.300"
          p={3}
          minW="160px"
          zIndex={1000}
          borderRadius="xl"
          style={{
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 0 0 1px rgba(0, 0, 0, 0.05)"
          }}
        >
          <VStack spacing={2} align="start">
            <Box>
              <Text fontSize="xs" fontWeight="medium" color="white">
                ${price ? price.toFixed(2) : 'N/A'}
              </Text>
            </Box>
            
            <Box width="100%" height="1px" bg="gray.600" />
            
            <Box>
              <Text fontSize="xs" color="white" fontWeight="medium">
                {storeName}
              </Text>
            </Box>
          </VStack>
        </Box>
      )}
    </Box>
  );
});

InfoBadge.displayName = 'InfoBadge';

export default InfoBadge;